import { ProfileVO } from '../../../vo/user/profile.vo';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { Profile, ProfileCriteria, ProfileScenario, ProfileWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * Commande dédiée aux profils utilisateur
 * Author sva
 */
export class ProfileCmd extends WizCommand<ProfileWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  /** retourne le wrapper pré-alimenté */
  public profileWrapper(): ProfileWrapper {
    const wrapper: ProfileWrapper = new ProfileWrapper();
    wrapper.criteria = new ProfileCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new ProfileScenario();
    wrapper.scenario.manageRoles = true;
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }

  public domainProfileWrapper(): ProfileWrapper {
    const wrapper: ProfileWrapper = this.profileWrapper();
    wrapper.criteria.domain = this.model.businessUnitEngine.currentDomain?.code;
    wrapper.criteria.businessUnitCode = null;

    return wrapper;
  }


  /**
   * chargement de tous les roles de la BU
   * @return ProfilCmd la commande configurée
   */
  public find(): ProfileCmd {
    const wrapper: ProfileWrapper = this.profileWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.PROFILE_API, wrapper);
    return this;
  }

  /**
   * chargement de tous les roles du domaine
   * @return ProfilCmd la commande configurée
   */
  public findForDomain(): ProfileCmd {
    const wrapper: ProfileWrapper = this.domainProfileWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.PROFILE_API, wrapper);
    return this;
  }


  /**
   * retour de service
   * gestion de retour selon la méthode d'appel
   */
  public wizResult(): void {
    super.wizResult();
    const wrapper: ProfileWrapper = this.result;
    
    if (!this.model.profileMap) {
      this.model.profileMap = new Map();
      this.model.profileFastMap = new Map();
    }

    if (!!wrapper) {
      // convertion de la liste de retour en liste de profileVO
      const profiles: ProfileVO[] = wrapper.entities.map((element: Profile) => new ProfileVO(this.model, element));


      // construction de la map
      const profileMap = this.model.profileMap;
      const profileFastMap = this.model.profileFastMap;
      let fastKey: string;

      profiles.forEach((r: ProfileVO) => {
        if(!profileMap.has(r.businessUnitCode)) {
          profileMap.set(r.businessUnitCode,new Map());
        }
        if(!profileMap.get(r.businessUnitCode).has(r.visionCode)) {
          profileMap.get(r.businessUnitCode).set(r.visionCode,new Map());
        }
        profileMap.get(r.businessUnitCode).get(r.visionCode).set(r.code, r);
      
        fastKey = this.model.profileEngine.getProfileKey(r);
        profileFastMap.set(fastKey, r);
      });
    }
  }

}
